import React, { useState } from "react";
import Image from "next/image";
import { cn } from "../../lib/utils";
import { useStudio } from "../../hooks/useStudio";
import { useConfiguratorContext } from "../../hooks/configurator/configurator-context";
import EnquiryDialog from "./EnquireDialog";
import SaveCodeDialog from "./SaveCodeDialog";
import { EnvironmentSwitcher } from "./EnvironmentSwitcher";

interface ConfiguratorHeaderProps {
  isMobile?: boolean;
  showDrawerToggle?: boolean;
  onToggleMobileDrawer?: () => void;
}

export const ConfiguratorHeader: React.FC<ConfiguratorHeaderProps> = ({
  isMobile = false,
  showDrawerToggle = false,
  onToggleMobileDrawer,
}) => {
  const { configuratorName } = useConfiguratorContext();
  const studio = useStudio();

  return (
    <div
      className={cn(
        "px-4 md:px-8 py-2 flex justify-between items-center bg-white/90 backdrop-blur-md",
        "border-b border-gray-200"
      )}
    >
      <div className="flex items-center min-w-0 flex-1">
        <Image
          src="/caroffshore-logo.png"
          width={64}
          height={64}
          alt="car off shore logo"
          className="mr-3"
        />
      </div>

      <div
        className={cn(
          "flex items-center gap-2 flex-shrink-0",
          !showDrawerToggle && "gap-8"
        )}
      >
        <div
          className={cn(
            "hidden items-center gap-4",
            !showDrawerToggle && "flex"
          )}
        >
          <EnvironmentSwitcher />
          <EnquiryDialog />
          <SaveCodeDialog />
        </div>

        {/* Mobile/Tablet Action Buttons */}
        <div
          className={cn(
            "hidden items-center gap-2",
            showDrawerToggle && "flex"
          )}
        >
          <EnquiryDialog label="Learn More" />
        </div>
      </div>
    </div>
  );
};
